import React from "react";
import { useNavigate } from "react-router-dom";
import { useNavigation } from "../../hooks/useNavigation";
import NavigationView from "./NavigationView";

function NavigationContainer() {
    const navigate = useNavigate();
    const navProps = useNavigation(navigate);
    return <NavigationView {...navProps} />;
}

export default NavigationContainer;
